import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { WorkOrder, CustomFieldsConfiguration } from '.././wo-models';
// import { WoUpdater, WoUpdaterService } from '.././wo-updater.service';


import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { BaseComponent } from '../../shared/base.component';
import { FormControl } from '@angular/forms';
//import { Customerdetails, CustomerDetailsListEntity, filteroptions } from '.././work-order-models';
import { LoaderService } from '../../shared/loader.service';

import { SerialNumber, PartLookupFilter } from '../../work-order/work-order-models';
import { WoService } from '../../work-order/work-order.service';

@Component({
  // moduleId: module.id,
  selector: 'serial-number-lookup',
  templateUrl: 'serial-number-lookup.component.html'
})
export class SerialNumberLookupComponent extends BaseComponent implements OnInit {

  @Input() PartId: number;
  @Input() WhId: number;
  @Input() SerialNo: string;
  @Input() serialNumber: SerialNumber[];
  @Input() LocationId?: number = null;
  @Input() BinId?: number = null;

  public Brand = new FormControl();
  public Model = new FormControl();
  public PartNo = new FormControl();
  public Description = new FormControl();

  public serialNumberval: SerialNumber[] = [];
  selectedSerialNumber: SerialNumber[] = [];
  public filterdetails: PartLookupFilter;

  public rows: number;
  public page: number;
  public order: string;
  public sortby: string;
  public rowsperOptions: any;
  public getRows: number;
  filteroptionId: number = 1;
  stacked: boolean;
  togglelist: boolean = false;
  pageCount: number = 1;
  //selectedId: Customerdetails;
  @Output() done = new EventEmitter();
  @Output() CustID = new EventEmitter();


  constructor(protected translateService: TranslateService, private loaderservice: LoaderService, protected sharedService: SharedService
    , protected woService: WoService) {
    super(sharedService, translateService)
    this.rowsperOptions = this.sharedService.getRowsPerOptions();
    this.getRows = this.sharedService.getRows();

  }
  ngOnInit() {
    if (this.filterdetails == null) {
      this.filterdetails = new PartLookupFilter;
    }

    this.rows = this.getRows;
    this.page = 0;
    this.order = "Category";
    this.sortby = "Asc";
    this.getSeriallist();

  } //onInit ends
  getSeriallist() {

    this.filterdetails.SortBy = this.sortby;
    this.filterdetails.OrderBy = this.order;
    this.filterdetails.StartRecord = this.page;
    this.filterdetails.EndRecord = this.rows;
    this.filterdetails.CompanyID = this.globalInfo().CompanyId;
    this.filterdetails.PartId = this.PartId;
    this.filterdetails.WhId = this.WhId;
    this.filterdetails.SerialNo = this.SerialNo;
    this.woService.getSerialNumbers(this.filterdetails.CompanyID, this.filterdetails.PartId, this.filterdetails.WhId, this.filterdetails.SerialNo, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy, this.serialNumber, this.LocationId, this.BinId).subscribe(resp => {

      //this.serialNumberval = resp;
      this.serialNumberval = resp.SerialNumbers.filter(a => !this.serialNumber.some(b => b.SerialNo == a.SerialNo));
      this.pageCount = resp.cnt;

      // this.serialNumberval = resp.filter(a=> {this.serialNumber.forEach(b=>b.SerialNo!=a.SerialNo)}) 
    });

  }

  togglechange() {
    super.toggleCollapse();
    this.togglelist = this.togglelist == true ? false : true
  }

  paginate(event) {

    this.filterdetails.SortBy = this.sortby;
    this.filterdetails.OrderBy = this.order;
    this.filterdetails.StartRecord = event.page;
    this.page = event.page;
    this.filterdetails.EndRecord = event.rows;
    this.rows = event.rows;

    this.filterdetails.CompanyID = this.globalInfo().CompanyId;
    this.filterdetails.PartId = this.PartId;
    this.filterdetails.WhId = this.WhId;
    this.filterdetails.SerialNo = this.SerialNo != null ? this.SerialNo : '';
    this.woService.getSerialNumbers(this.filterdetails.CompanyID, this.filterdetails.PartId, this.filterdetails.WhId, this.filterdetails.SerialNo, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy, this.serialNumber, this.LocationId, this.BinId).subscribe(resp => {

      //this.serialNumberval = resp;
      this.serialNumberval = resp.SerialNumbers.filter(a => !this.serialNumber.some(b => b.SerialNo == a.SerialNo));
      this.pageCount = resp.cnt;

      // this.serialNumberval = resp.filter(a=> {this.serialNumber.forEach(b=>b.SerialNo!=a.SerialNo)}) 
    });
  }
  sort(event) {
    debugger;
    if (event.order == 1)
      this.sortby = "Asc";
    else
      this.sortby = "Desc";
    this.filterdetails.SortBy = this.sortby;
    this.filterdetails.OrderBy = event.field;
    this.order = event.field;
    this.filterdetails.StartRecord = this.page;
    this.filterdetails.EndRecord = this.rows;

    this.filterdetails.CompanyID = this.globalInfo().CompanyId;
    this.filterdetails.PartId = this.PartId;
    this.filterdetails.WhId = this.WhId;
    this.filterdetails.SerialNo = this.SerialNo != null ? this.SerialNo : '';
    this.woService.getSerialNumbers(this.filterdetails.CompanyID, this.filterdetails.PartId, this.filterdetails.WhId, this.filterdetails.SerialNo, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy, this.serialNumber, this.LocationId, this.BinId).subscribe(resp => {

      //this.serialNumberval = resp;
      this.serialNumberval = resp.SerialNumbers.filter(a => !this.serialNumber.some(b => b.SerialNo == a.SerialNo));
      this.pageCount = resp.cnt;

      // this.serialNumberval = resp.filter(a=> {this.serialNumber.forEach(b=>b.SerialNo!=a.SerialNo)}) 
    });
  }


  // onRowSelect(value) {

  //   this.done.emit(value)//value.data.CustomerId);
  // }

  closePopup() {
    this.done.emit(this.serialNumber);
  }

  SelectedSerail() {
    this.done.emit(this.selectedSerialNumber.concat(this.serialNumber))
  }

}